import React, {useEffect, useState} from "react";
import TopBanner from "./topBanner";
import BecomePartner from "./becomePartner";
import BasicInfo from "./basicInfo";
import MoreDetails from "./moreDetails";
import LoggingIn from "./loggingIn";
import {useDispatch, useSelector} from "react-redux";
import {SIGN_UP_STATE} from "../../Actions/signupAction";

const stateGreenLineMap = {
    "INIT": 1,
    "BASIC_INFO": 2,
    "MORE_DETAILS": 3,
    "LOGGING_IN": 4
}

const SignupWrapper = () => {
    const [state, setState] = useState("INIT");
    const [basicInfo, setBasicInfo] = useState({});
    const signupState = useSelector(state => state.signingUpState);
    const dispatch = useDispatch();
    const getStateWiseForm = () => {
        switch (state) {
            case "BASIC_INFO":
                return <BasicInfo setState={setState} setBasicInfo={setBasicInfo}/>
                break;

            case "MORE_DETAILS":
                return <MoreDetails setState={setState} basicInfo={basicInfo}/>
                break;

            case "INIT":
            default:
                return <BecomePartner handleNext={() => setState("BASIC_INFO")}/>
        }
    }

    useEffect(() => {
        if (signupState === false) {
            setState("MORE_DETAILS");
            setTimeout(() => {
                dispatch({
                    type: SIGN_UP_STATE,
                    payload: null
                });
            }, 10000);
        }
    }, [signupState])

    if (state === "LOGGING_IN")
        return (
            <div>
                <TopBanner total={4} progress={stateGreenLineMap[state]}></TopBanner>
                <LoggingIn/>
            </div>
        );

    return (
        <div>
            <TopBanner total={4} progress={stateGreenLineMap[state]}/>
            <div className="signup-forms-back">
                <div className="signup-forms-wrapper">{getStateWiseForm()}</div>
                {signupState === false &&
                <div className="alert alert-danger position-absolute wrong-pass-notification fw-bold">
                    Sign up failed. User already exists. Please try with a
                    different email.</div>}
            </div>
        </div>
    )
}

export default SignupWrapper;
